import { render, staticRenderFns } from "./SalesTypeListAddNew.vue?vue&type=template&id=54a105a1"
import script from "./SalesTypeListAddNew.vue?vue&type=script&lang=js"
export * from "./SalesTypeListAddNew.vue?vue&type=script&lang=js"
import style0 from "./SalesTypeListAddNew.vue?vue&type=style&index=0&id=54a105a1&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports